// extracted by mini-css-extract-plugin
export default {"container":"Loader_container__iBgQl","loader":"Loader_loader__De3pH","loaderAnim":"Loader_loaderAnim__05XKk"};